import { render, staticRenderFns } from "./PriorityForm.vue?vue&type=template&id=61449bb9"
import script from "./PriorityForm.vue?vue&type=script&lang=js"
export * from "./PriorityForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports